<template>
  <div>
    <v-tabs
      v-model="tab"
    >
      <v-tabs-slider color="accent" />

      <v-tab
        v-for="title in tabTitles"
        :key="title"
      >
        {{ title }}
      </v-tab>

      <v-tab-item>
        <div v-for="(value, key, index) in cascadeItems" :key="index" style="margin: 20px 0">
          <h3>{{ cascadeTitles[index] }}</h3>

          <v-data-table
            :items="value"
            :headers="headers"
            :loading="loading"
            hide-actions
          >
            <template #items="props">
              <template v-for="header in headers">
                <td v-if="header.value === 'action'">
                  <template v-if="props.item.active && props.item.is_auto">
                    <v-btn
                      :color="isThemeDark ? 'primary' : undefined"
                      text
                      small
                      @click="changeOrder(`cascadeItems.${key}`, 'up', props)"
                    >
                      <v-icon color="green">arrow_upward</v-icon>
                    </v-btn>

                    <v-btn
                      :color="isThemeDark ? 'primary' : undefined"
                      text
                      small
                      @click="changeOrder(`cascadeItems.${key}`, 'down', props)"
                    >
                      <v-icon color="red">arrow_downward</v-icon>
                    </v-btn>
                  </template>

                  <div v-else-if="props.item.active && !props.item.is_auto">Система не доступна</div>

                  <div v-else>Система отключена</div>
                </td>

                <td v-else-if="header.value === 'weight_action' && props.item.active && props.item.is_auto">
                  <v-text-field
                    v-model="props.item.weight_input"
                    style="max-width: 80px"
                    color="accent"
                    :rules="[rules.required, rules.weight(`cascadeItems.${key}`)]"
                  />
                </td>

                <td v-else-if="header.value === 'active'" style="padding-top: 10px;">
                  <v-checkbox
                    v-model="props.item.active"
                    :disabled="!props.item.is_auto && props.item.active"
                    color="accent"
                    @click.stop="togglePayment(props.item)"
                  />
                </td>

                <td v-else-if="header.value === 'min'">
                  <v-text-field
                    v-if="props.item.is_auto"
                    v-model="props.item.min"
                    color="accent"
                    style="max-width: 150px"
                    :rules="[rules.required, rules.counter]"
                  />
                </td>

                <td v-else-if="header.value === 'max'">
                  <v-text-field
                    v-if="props.item.is_auto"
                    v-model="props.item.max"
                    color="accent"
                    style="max-width: 150px"
                    :rules="[rules.required, rules.counter]"
                  />
                </td>

                <td v-else-if="header.value === 'btn' && props.item.is_auto">
                  <v-btn
                    :disabled="!inputChanged(props.item, `cascadeItems.${key}`)"
                    color="primary"
                    @click="onClick(props.item)"
                  >
                    Сохранить
                  </v-btn>
                </td>

                <td v-else-if="header.value === 'public_name'">
                  <p style="width: 160px">{{ props.item[header.value] }} <br> {{ getPayway(props.item) }}</p>
                </td>

                <td v-else>{{ props.item.is_auto ? props.item[header.value] : '' }}</td>
              </template>
            </template>
          </v-data-table>
        </div>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          :items="replenishment"
          :headers="headers"
          :loading="loading"
          hide-actions
          style="margin: 20px 0"
        >
          <template #items="props">
            <template v-for="header in headers">
              <td v-if="header.value === 'action'">
                <template v-if="props.item.active">
                  <v-btn
                    :color="isThemeDark ? 'primary' : undefined"
                    text
                    small
                    @click="changeOrder('replenishment', 'up', props)"
                  >
                    <v-icon color="green">arrow_upward</v-icon>
                  </v-btn>

                  <v-btn
                    :color="isThemeDark ? 'primary' : undefined"
                    text
                    small
                    @click="changeOrder('replenishment', 'down', props)"
                  >
                    <v-icon color="red">arrow_downward</v-icon>
                  </v-btn>
                </template>

                <div v-else>Система отключена</div>
              </td>

              <td v-else-if="header.value === 'weight_action' && props.item.active">
                <v-text-field
                  v-model="props.item.weight_input"
                  color="accent"
                  style="max-width: 80px"
                  :rules="[rules.required, rules.weight('replenishment')]"
                />
              </td>

              <td v-else-if="header.value === 'active'" style="padding-top: 10px;">
                <v-checkbox
                  v-model="props.item.active"
                  color="accent"
                  @click.stop="togglePayment(props.item)"
                />
              </td>

              <td v-else-if="header.value === 'min'">
                <v-text-field
                  v-if="props.item.is_fiat"
                  v-model="props.item.min"
                  color="accent"
                  style="max-width: 150px"
                  :rules="[rules.required, rules.counter]"
                />
              </td>

              <td v-else-if="header.value === 'max'">
                <v-text-field
                  v-if="props.item.is_fiat"
                  v-model="props.item.max"
                  color="accent"
                  style="max-width: 150px"
                  :rules="[rules.required, rules.counter]"
                />
              </td>

              <td v-else-if="header.value === 'btn'">
                <v-btn
                  :disabled="!inputChanged(props.item, 'replenishment')"
                  color="primary"
                  @click="onClick(props.item)"
                >
                  Сохранить
                </v-btn>
              </td>

              <td v-else-if="header.value === 'public_name'">
                {{ props.item[header.value] }} <br> {{ getAdditionalInfo(props.item) }}
              </td>

              <td v-else>{{ props.item[header.value] }}</td>
            </template>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item>
        <v-data-table
          :items="withdrawal"
          :headers="headers"
          :loading="loading"
          hide-actions
          style="margin: 20px 0"
        >
          <template #items="props">
            <template v-for="header in headers">
              <td v-if="header.value === 'action'">
                <template v-if="props.item.active">
                  <v-btn
                    :color="isThemeDark ? 'primary' : undefined"
                    text
                    small
                    @click="changeOrder('withdrawal', 'up', props)"
                  >
                    <v-icon color="green">arrow_upward</v-icon>
                  </v-btn>

                  <v-btn
                    :color="isThemeDark ? 'primary' : undefined"
                    text
                    small
                    @click="changeOrder('withdrawal', 'down', props)"
                  >
                    <v-icon color="red">arrow_downward</v-icon>
                  </v-btn>
                </template>

                <div v-else>Система отключена</div>
              </td>

              <td v-else-if="header.value === 'weight_action' && props.item.active">
                <v-text-field
                  v-model="props.item.weight_input"
                  style="max-width: 80px"
                  color="accent"
                  :rules="[rules.required, rules.weight('withdrawal')]"
                />
              </td>

              <td v-else-if="header.value === 'active'" style="padding-top: 10px;">
                <v-checkbox
                  v-model="props.item.active"
                  color="accent"
                  @click.stop="togglePayment(props.item)"
                />
              </td>

              <td v-else-if="header.value === 'min'">
                <v-text-field
                  v-model="props.item.min"
                  style="max-width: 150px"
                  color="accent"
                  :rules="[rules.required, rules.counter]"
                />
              </td>

              <td v-else-if="header.value === 'max'">
                <v-text-field
                  v-model="props.item.max"
                  style="max-width: 150px"
                  color="accent"
                  :rules="[rules.required, rules.counter]"
                />
              </td>

              <td v-else-if="header.value === 'btn'">
                <v-btn
                  :disabled="!inputChanged(props.item, 'withdrawal')"
                  color="primary"
                  @click="onClick(props.item)"
                >
                  Сохранить
                </v-btn>
              </td>

              <td v-else-if="header.value === 'public_name'">
                {{ props.item[header.value] }}
              </td>

              <td v-else>{{ props.item[header.value] }}</td>
            </template>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import {
  changePaymentOrder, getPaymentSystem, updatePaymentLimits
} from '../../api/payment'

export default {
  name: 'PaymentSystems',
  data () {
    return {
      loading: false,
      tab: null,
      isThemeDark: JSON.parse(localStorage.getItem('isThemeDark')) || false,
      tabTitles: ['Каскад', 'Пополнениe', 'Вывод'],
      cascadeTitles: ['Номер счета Сбербанк', 'СБП', 'Банк. карта'],
      cascadeItems: {
        bank_account_number: [],
        sbp: [],
        cards: []
      },
      replenishment: [],
      withdrawal: [],
      disable: false,
      rules: {
        required: value => !!value || 'Обязательное поле!',
        counter: value => {
          const regex = /^\d{1,7}$/
          return regex.test(value) || 'Неверное значение!'
        },
        weight: key => value => {
          const array = this.getArray(key)
          const maxWeight = array.reduce((prev, current) => (prev.weight > current.weight) ? prev : current).weight
          const regex = /^\d{1,2}$/
          if (!value || value < 1 || value > maxWeight)
            return `Введите число от 1 до ${maxWeight}`
          return regex.test(value) || 'Неверное значение!'
        }
      },
      headers: [
        {
          text: 'Позиция', value: 'weight', sortable: false
        },
        {
          text: 'Наименование', value: 'public_name', sortable: false
        },
        {
          text: 'Действие', value: 'action', sortable: false
        },
        {
          text: 'Номер позиции', value: 'weight_action', sortable: false
        },
        {
          text: 'Вкл / Выкл', value: 'active', sortable: false
        },
        {
          text: 'Лимиты мин.', value: 'min', sortable: false
        },
        {
          text: 'Лимиты макс.', value: 'max', sortable: false
        },
        {
          text: '', value: 'btn', sortable: false
        }
      ]
    }
  },
  async mounted () {
    EventBus.$on('theme-changed', e => this.isThemeDark = e)
    await this.getPayments()
  },
  beforeDestroy () {
    EventBus.$off('theme-changed')
  },
  methods: {
    async getPayments () {
      try {
        this.loading = true
        const res = await getPaymentSystem()
        this.processPayment(res.data)
      } finally {
        this.loading = false
      }
    },
    processPayment (payment) {
      for (const key in payment)
        this[key] = payment[key].map(item => ({
          ...item,
          weight_input: item.weight
        })).sort((a, b) => {
          if (a.active !== b.active)
            return a.active ? -1 : 1

          if (a.is_auto !== b.is_auto)
            return a.is_auto ? -1 : 1

          return 0
        })

      this.replenishment.forEach(item => {
        if (item.type !== 'auto' && item.is_auto != null) {
          if (item.method.includes('bank_account_number'))
            this.cascadeItems.bank_account_number.push(item)

          if (item.method.includes('sbp'))
            this.cascadeItems.sbp.push(item)

          if (item.method.includes('cards'))
            this.cascadeItems.cards.push(item)
        }

        if (item.method === 'sberpay_vip' || item.method === 'sbp_vip' || item.method === 'cards_vip' || item.method === 'tpay_vip')
          item.public_name = `VIP ${item.public_name}`
      })

      this.replenishment = this.replenishment.filter(item => !item.is_auto || (item.is_auto && !item.active))
    },
    getAdditionalInfo (item) {
      if (item.type !== 'auto') {
        let result = item.payway.replace(/_/g, ' ').charAt(0)
          .toUpperCase() + item.payway.slice(1).replace(/_/g, ' ')
        if (item.extra_info && item.extra_info.postfix)
          result += ` ${item.extra_info.postfix}`
        return result
      }

      if (item.type === 'auto')
        return 'Каскад'
    },
    getPayway (item) {
      const payway = item.payway.replace(/_/g, ' ')
      let newPayway = payway.charAt(0).toUpperCase() + payway.slice(1)
      if (item.extra_info && item.extra_info.postfix)
        newPayway += ` ${item.extra_info.postfix}`
      return newPayway
    },
    getArray (key) {
      return key.includes('.')
        ? key.split('.').reduce((obj, key) => obj?.[key], this)
        : this[key]
    },
    async changeOrder (type, direction, props) {
      if (props.item.active === false) return
      const array = this.getArray(type)
      if (!Array.isArray(array)) return
      const targetIndex = direction === 'up' ? props.index - 1 : props.index + 1
      if (array[targetIndex] && array[targetIndex].active) {
        try {
          this.loading = true
          await changePaymentOrder(props.item.id, { direction })
        } catch (error) { alert(`${error.response.data.message}. Попробуйте обновить страницу`) }
      } else {
        this.loading = false
        return
      }

      this.clear()
      await this.getPayments()
      this.loading = false
    },
    async togglePayment (item) {
      this.loading = true
      const params = {}
      params.active = !item.active
      if (this.tab === 0 && item.active === false && item.is_auto === false) {
        params.active = undefined
        params.is_auto = true
      } else if (this.tab === 1 && item.active === false && item.is_auto === true) {
        params.active = undefined
        params.is_auto = false
      }
      try {
        await updatePaymentLimits(item.id, params)
        this.clear()
        await this.getPayments()
      } catch (error) { alert(`${error.response.data.message}. Попробуйте обновить страницу`) }
    },
    async onClick (item, needed = true) {
      try {
        this.loading = true
        if (item.weight !== parseInt(item.weight_input))
          await changePaymentOrder(item.id, { weight: parseInt(item.weight_input) })
        if (needed && item.min && item.max)
          await updatePaymentLimits(item.id, {
            min: parseInt(item.min),
            max: parseInt(item.max)
          })
        this.clear()
        await this.getPayments()
      } catch (error) { alert(`${error.response.data.message}. Попробуйте обновить страницу`) }
    },
    inputChanged (item, key) {
      const array = this.getArray(key)
      const maxWeight = array.reduce((prev, current) => (prev.weight > current.weight) ? prev : current).weight
      if (key === 'replenishment' && !item.is_fiat)
        return (item.weight_input && parseInt(item.weight_input) > 0 && parseInt(item.weight_input) <= maxWeight)

      return (item.weight_input && parseInt(item.weight_input) > 0 && parseInt(item.weight_input) <= maxWeight)
        && (/^\d{1,9}$/.test(item.min) && parseInt(item.min) > 99)
        && (/^\d{1,9}$/.test(item.min) && parseInt(item.max) > 99) && (parseInt(item.max) > parseInt(item.min))
    },
    clear () {
      this.withdrawal = []
      this.replenishment = []
      for (const key in this.cascadeItems)
        this.cascadeItems[key] = []
    }
  }
}
</script>
